// extracted by mini-css-extract-plugin
module.exports = {"conflictDescription":"ConflictDescription_conflictDescription__mDTL7"};